export const SNACKBAR_COPIES = {
  DELETE_ARCHIVE: "Archive Successfully Deleted!",
  UPDATE_ARCHIVE_INFO_SUCCESS:
    "Congrats! The archive's information has been updated!",
  UPDATE_ARCHIVE_INFO_FAILURE:
    "Sorry! It looks like something went wrong with updating the archive. See the console for the error.",
};
